module.exports = __webpack_public_path__ + "img/lun4.76ae30be.webp";